import { TemplatePageProps } from './types'
import { PoolClashEntity } from './entity'
import Icon from 'images/games/pool-clash/icon.png'
import Detail1 from 'images/games/pool-clash/detail1.png'
import {
  DominoesLink,
  DunkShotLink,
  MatchNFlipLink,
  NumbersBlitzLink,
  PlaySolitaireOnlineLink,
  Pocket7GamesLink,
  TileBlitzLink,
  TwentyOneGoldLink,
} from '../../components'
import { Pocket7GamesSwiper } from './pocket7games'

export const PoolClashDetail: TemplatePageProps = {
  entity: {
    ...PoolClashEntity,
    logo: Icon,
    title: (
      <>
        Pool Clash: The Ultimate <strong>8 Ball Online</strong> Challenge
      </>
    ),
    description: (
      <>
        Looking for a <strong>pool game</strong> that actually hits different? <strong>Pool Clash</strong>, exclusively
        inside the Pocket7Games app, brings the real energy of the pool hall straight to your screen! From the first
        break to the final <strong>8 pool</strong> shot, it’s all about smart plays, slick aim, and nonstop fun. Ready
        to rack &#39;em?
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: (
        <>
          Master the Cue in This <strong>Billiards Online</strong> Battle
        </>
      ),
      description: (
        <>
          Pool Clash isn’t your average tap-and-hope game. It’s a full-blown <strong>billiards online</strong>{' '}
          experience where skill takes the spotlight. In fast-paced <strong>8 ball online</strong> matches, the goal is
          simple: clear as many balls as possible and rack up the highest score before time runs out. The game keeps it
          smooth with lifelike physics, responsive controls, and table setups that feel like the real deal. Whether
          you&#39;re chasing a high score or looking for your next challenge, Pool Clash is one of the most exciting{' '}
          <strong>online pool games</strong> available today.
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Explore More Online Games in Pocket7Games App</>,
      description: (
        <>
          Craving more ways to sharpen your shot? Once you’re into Pool Clash, there’s no going back. But don’t stop
          there—
          <Pocket7GamesLink /> has plenty more to keep the good times rolling. Try puzzle classics like{' '}
          <NumbersBlitzLink />, card showdowns in <PlaySolitaireOnlineLink /> and <TwentyOneGoldLink />, or test your
          aim in <DunkShotLink />. Want something different? Go for <TileBlitzLink />, <DominoesLink />, or high-speed
          rounds in <MatchNFlipLink />. Whether you&#39;re here for chill vibes or competitive fire, the world of{' '}
          <strong>online pool games</strong>—and beyond—is right at your fingertips.
        </>
      ),
    },
  ],
} as TemplatePageProps
